import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";

const LINKS = [
  ["kalkulator", "Kalkulator"],
  ["testimoni", "Testimoni"],
  ["keunggulan", "Keunggulan"],
  ["cara-kerja", "Cara Kerja"],
  ["faq", "FAQ"],
  ["/blog", "Blog"],
];

export const Navbar = ({ announcement, gacha }) => {
  const [open, setOpen] = useState(false);
  const links = gacha ? [...LINKS, ["/brewek", "Brewek"]] : LINKS;
  const go = (id) => {
    setOpen(false);
    if (id.startsWith("/")) window.location.href = id;
    else scrollToId(id);
  };
  return (
    <header className="fixed inset-x-0 top-0 z-50" data-testid="site-navbar">
      {announcement ? (
        <div data-testid="announcement-bar" className="bg-volt px-4 py-1.5 text-center font-mono text-[12px] font-medium text-ink">
          {announcement}
        </div>
      ) : null}
      <div className="border-b border-white/[0.06] bg-ink/70 backdrop-blur-xl">
        <nav className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 md:px-10">
          <Logo />
          <ul className="hidden items-center gap-8 lg:flex">
            {links.map(([id, label]) => (
              <li key={id}>
                <button data-testid={`nav-link-${id.replace("/", "")}`} onClick={() => go(id)} className="link-line text-sm text-zinc-300 transition-colors hover:text-paper">
                  {label}
                </button>
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-3">
            <button
              data-testid="nav-cta-button"
              onClick={() => go("kalkulator")}
              className="group hidden items-center gap-1.5 rounded-full bg-volt px-5 py-2.5 text-sm font-semibold text-ink transition-transform duration-300 hover:scale-[1.04] sm:flex"
            >
              Convert Sekarang
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
            </button>
            <button data-testid="nav-mobile-toggle" onClick={() => setOpen((v) => !v)} className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-paper lg:hidden" aria-label="Menu">
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </nav>
        <AnimatePresence>
          {open ? (
            <motion.ul
              data-testid="nav-mobile-menu"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              className="overflow-hidden border-t border-white/[0.06] px-5 lg:hidden"
            >
              {links.map(([id, label]) => (
                <li key={id}>
                  <button data-testid={`nav-mobile-link-${id.replace("/", "")}`} onClick={() => go(id)} className="w-full py-4 text-left font-display text-2xl text-paper">
                    {label}
                  </button>
                </li>
              ))}
            </motion.ul>
          ) : null}
        </AnimatePresence>
      </div>
    </header>
  );
};
